import React from 'react';
import {
  Chip,
  Stack,
  Tooltip,
} from '@mui/material';
import GlutenFreeIcon from './GlutenFreeIcon';
import SpicyIcon from './SpicyIcon';
import HalalIcon from './HalalIcon';
import VegetarianIcon from './VegetarianIcon';
import VeganIcon from './VeganIcon';
import HealthyIcon from './HealthyIcon';
import StarIcon from './StarIcon';
import DrinkIcon from './DrinkIcon';
import DesertIcon from './DesertIcon';
import KosherIcon from './KosherIcon';
import AwardIcon from './AwardIcon';
import UtensilIcon from './UtensilIcon';

function DietaryTags(
  {
    tags = [],
    showLabel = false,
    wrap = showLabel ? 'wrap' : 'nowrap',
    ...props
  },
) {
  if (!tags.length) {
    return null;
  }
  return (
    <Stack direction="row" gap={0.5} flexWrap={wrap} sx={{ overflow: 'hidden', ...props.sx }}>
      {tags.map((tag) => {
        if (!ICONS[tag]) {
          return null;
        }
        const label = tag.replace(/^is(OrHas)?/, '').replace(/^has?/, '');
        if (showLabel) {
          return (
            <Chip
              key={tag}
              icon={ICONS[tag]}
              label={label}
              sx={{
                height: 'fit-content',
                borderRadius: '6px',
                backgroundColor: 'background.elevation1',
                '& .MuiChip-icon': {
                  ml: 0,
                },
                '& .MuiChip-label': {
                  px: 1,
                  fontSize: '12px',
                  lineHeight: '16px',
                  letterSpacing: '0.8px',
                  fontWeight: 700,
                  color: 'text.secondary',
                },
              }}
            />
          );
        }
        return <Tooltip key={tag} enterTouchDelay={0} title={label}><div>{ICONS[tag]}</div></Tooltip>;
      })}
    </Stack>
  );
}

const ICONS = {
  isVegan: <VeganIcon />,
  isHalal: <HalalIcon />,
  isVegetarian: <VegetarianIcon />,
  isGlutenFree: <GlutenFreeIcon />,
  isSpicy: <SpicyIcon />,
  isKosher: <KosherIcon />,
  isHealthy: <HealthyIcon />,
  isPopular: <StarIcon />,
  isOrHasDrinks: <DrinkIcon />,
  isOrHasDessert: <DesertIcon />,
  hasAward: <AwardIcon />,
  canBeVegetarian: <VegetarianIcon />,
  isUtensils: <UtensilIcon />,
};
export default DietaryTags;
